<template>
    <header class="header-goodhome">
        <Heading
            :level="1"
            class="container"
        >
            <BaseImage
                class="header-goodhome__logo col-12"
                :data="{ src: goodhomeLogo, alt: 'GoodHome Fundacja' }"
            />
        </Heading>
    </header>
</template>

<script>
import BaseImage from '~/components/common/Image/BaseImage';
import Heading from '~/src/components/ui/Heading';

const goodhomeLogo = require('~/static/images/gh-foundation/logo.png');

export default {
    name: 'HeaderGoodhome',
    components: {
        Heading,
        BaseImage,
    },
    data() {
        return {
            /**
             * Goodhome logo
             */
            goodhomeLogo,
        };
    },
};
</script>

<style lang="scss">
    .header-goodhome {
        height: 64px;

        &__logo {
            margin: 20px 0 2px 0;
            height: 38px;
            width: auto;
            padding: 0;
        }
    }

    @media screen and (min-width: $mf-breakpoint-tablet) {
        .header-goodhome {
            height: 80px;
            border-bottom: 1px solid $color-slate20;

            &__logo {
                height: 50px;
                margin: 8px 0 0;
            }
        }
    }

    @media screen and (min-width: $mf-breakpoint-small-desktop) {
        .header-goodhome__logo {
            padding: 0 15px;
        }
    }
</style>
